import { EnglishArabicDTO } from "bbsf-controls"
import { LookUpItem } from "./LookupItem"
export class LookupModel
{
      ID:number
      UpdatedID:number
      IDEncrypted :string
      LookupGroupID?:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      Description :EnglishArabicDTO=new EnglishArabicDTO();
      LookupGroupName :EnglishArabicDTO=new EnglishArabicDTO();
      LookupItems :LookUpItem[]=[];
      SysName :string
      Manageable :boolean
      }
     